<template>
    <div class="dialog-screen">
        <div class="table-layout">
            <el-table class="thin" :data="pageVendorImpList" :height="tableHeight" ref="vendorImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="300" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column label="供应商名称">
                    <el-table-column prop="name" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.vendorName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.vendorName" :title="rows.row.validateInfo.vendorName.errorMsg"/>
                            <input type="text" v-else style="width:180px" @change="commonChangeEvent" v-model="rows.row.vendorName"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="统一社会信用代码">
                    <el-table-column prop="name" width="200">
                        <template slot-scope="rows">
                            <input type="text" v-if="!rows.row.validateInfo.socialCreditCode.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 240px" v-model="rows.row.socialCreditCode" :title="rows.row.validateInfo.socialCreditCode.errorMsg"/>
                            <input type="text" v-else style="width:180px" @change="commonChangeEvent" v-model="rows.row.socialCreditCode"/>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="省" prop="provinceName" width="180">
                    <template slot-scope="rows">
                        <input type="text" style="width:170px" v-model="rows.row.provinceName"/>
                    </template>
                </el-table-column>
                <el-table-column label="市" prop="cityName" width="180">
                    <template slot-scope="rows">
                        <input type="text" style="width:170px" v-model="rows.row.cityName"/>
                    </template>
                </el-table-column>
                <el-table-column label="县/区" prop="countyName" width="180">
                    <template slot-scope="rows">
                        <input type="text" style="width:170px" v-model="rows.row.countyName"/>
                    </template>
                </el-table-column>
                <el-table-column label="详细地址" prop="street" width="180">
                    <template slot-scope="rows">
                        <input type="text" style="width:170px" v-model="rows.row.street"/>
                    </template>
                </el-table-column>
                <el-table-column label="联系人" prop="contactName" width="180">
                    <template slot-scope="rows">
                        <input type="text" style="width:170px" v-model="rows.row.contactName"/>
                    </template>
                </el-table-column>
                <el-table-column label="联系手机号" prop="contactTel" width="180">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.contactTel.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 170px" v-model="rows.row.contactTel" :title="rows.row.validateInfo.contactTel.errorMsg"/>
                        <input type="text" v-else style="width:170px" @change="commonChangeEvent" v-model="rows.row.contactTel"/>
                    </template>
                </el-table-column>
                <el-table-column label="联系邮箱" prop="contactEmail" width="180">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.contactEmail.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 90px" v-model="rows.row.contactEmail" :title="rows.row.validateInfo.contactEmail.errorMsg"/>
                        <input type="text" v-else style="width:170px" @change="commonChangeEvent" v-model="rows.row.contactEmail"/>
                    </template>
                </el-table-column>
                <el-table-column label="关系开始日期" align="center">
                    <el-table-column prop="dateStart" width="90" align="center" :render-header="setDateStart">
                        <template slot-scope="rows">
                            <div v-if="rows.row.dateStart == null" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.dateStart.errorMsg">
                                <span>&nbsp;</span>
                            </div>
                            <div v-else>
                                <div v-if="!rows.row.validateInfo.dateStart.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.dateStart.errorMsg">
                                    <span>{{rows.row.dateStart}}</span>
                                </div>
                                <span v-else>{{rows.row.dateStart}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="关系截止日期" align="center">
                    <el-table-column prop="dateEnd" width="90" align="center" :render-header="setDateEnd">
                        <template slot-scope="rows">
                            <div v-if="rows.row.dateEnd == null" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.dateEnd.errorMsg">
                                <span>&nbsp;</span>
                            </div>
                            <div v-else>
                                <div v-if="!rows.row.validateInfo.dateEnd.validateOk" style="background-color: #edd28b; width: 100%;height: 100%" :title="rows.row.validateInfo.dateEnd.errorMsg">
                                    <span>{{rows.row.dateEnd}}</span>
                                </div>
                                <span v-else>{{rows.row.dateEnd}}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="评级" prop="starLevel" width="180">
                    <template slot-scope="rows">
                        <el-rate v-model="rows.row.starLevel" @change="commonChangeEvent"></el-rate>
                    </template>
                </el-table-column>
                <el-table-column label="业务描述" prop="bizDesc" width="180">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.bizDesc.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.bizDesc" :title="rows.row.validateInfo.bizDesc.errorMsg"/>
                        <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.bizDesc"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doVendorImpModelImport">逐条检查导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateVendorImpModel(true)">逐条检查</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="downloadVendorImpModel">导出</div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'

    import vendorApi from '../../api/vendor'

    import SwbShopDeviceImpSetDate from '../retailer/ShopDeviceImpSetDate';
    Vue.regist(SwbShopDeviceImpSetDate);

    export default {
        name: 'swb-mercht-vendor-imp-check',
        desc: '供应商导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageVendorImpList: {},
                vendorImpDto: {
                    impInfoList: [],
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                max_quantity_per_item: 500,
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            //
            let self = this;
            let theLoading = MsgBox.loading();
            let vendorImpInfoList = this.fileObj.extra.vendorImpInfoList || [];
            vendorImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    vendorName: {validateOk: true},
                    socialCreditCode: {validateOk: true},
                    contactTel: {validateOk: true},
                    contactEmail: {validateOk: true},
                    dateStart: {validateOk: true},
                    dateEnd: {validateOk: true},
                    bizDesc: {validateOk: true},
                };
            });
            this.vendorImpDto.impInfoList = vendorImpInfoList;
            //
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageVendorImpInfoList();
            // this.getCurrUserInfo();
            theLoading.close();
        },
        methods: {
//            getCurrUserInfo(){
//                let self = this;
//                userApi.getUserInfoByContext({}, function (result) {
//                    if(result.type == 'info') {
//                        let scopeEntity = result.data.scopeEntity;
//                        self.scopeId = scopeEntity.scopeId;
//                    }
//                });
//            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            //自动合并数据行
            commonChangeEvent(){
                this.checkData();
            },
//            dlgSetDevcDefImpDto: function (vendorImpDto) {
//                let self = this;
//                //
//                let vendorImpInfoList = vendorImpDto.impInfoList;
//                vendorImpInfoList.forEach(function (el) {
//                    el.validateInfo = {
//                        name: {validateOk: true},
//                        catName: {validateOk: true},
//                        brandName: {validateOk: true},
//                        model: {validateOk: true},
//                        fixedSpec: {validateOk: true},
//                        title: {validateOk: true},
////                    innerDevcCatName: {validateOk: true},
//                        theUnit: {validateOk: true},
//                        durableLife: {validateOk: true},
//                        asmbAccCount: {validateOk: true},
//                        memo: {validateOk: true}
//                    };
//                });
//                self.vendorImpDto = vendorImpDto;
//                setTimeout(
//                    function () {
//                        self.checkData();
//                    }, 1000
//                );
//
//            },
            checkData () {
                let self = this;
                let rows = this.vendorImpDto.impInfoList.clone();
                for(let i = 0; i < rows.length; i++) {
                    let vendorImpDto = rows[i];
                    vendorImpDto.validateInfo = {
                        vendorName: {validateOk: true},
                        socialCreditCode: {validateOk: true},
                        contactTel: {validateOk: true},
                        contactEmail: {validateOk: true},
                        dateStart: {validateOk: true},
                        dateEnd: {validateOk: true},
                        bizDesc: {validateOk: true},
                    };
                    // 检查 [定义名称]
                    if(!Utils.isNoB(vendorImpDto.vendorName)) {
                        vendorImpDto.vendorName = this.replaceSL(vendorImpDto.vendorName, ' ');
                    }
                    if(Utils.isNoB(vendorImpDto.vendorName)) {
                        vendorImpDto.validateInfo.vendorName = {
                            validateOk: false,
                            errorMsg: "[供应商名称]单元不可为空"
                        };
                    } else if(vendorImpDto.vendorName.length > 60) {
                        vendorImpDto.validateInfo.vendorName = {
                            validateOk: false,
                            errorMsg: "[供应商名称]单元长度最大60，当前[" + vendorImpDto.vendorName.length + "]"
                        };
                    }
                    // 检查 [统一社会信用代码]
                    if(!Utils.isNoB(vendorImpDto.socialCreditCode)) {
                        vendorImpDto.socialCreditCode = this.replaceSL(vendorImpDto.socialCreditCode, ' ');
                    }
                    if(Utils.isNoB(vendorImpDto.socialCreditCode)) {
                        vendorImpDto.validateInfo.socialCreditCode = {
                            validateOk: false,
                            errorMsg: "[统一社会信用代码]单元不能为空"
                        };
                    } else if(vendorImpDto.socialCreditCode.length > 20) {
                        vendorImpDto.validateInfo.socialCreditCode = {
                            validateOk: false,
                            errorMsg: "[统一社会信用代码]单元长度最大20，当前[" + vendorImpDto.socialCreditCode.length + "]"
                        };
                    }
                    // 检查 [联系手机号]
                    if(!Utils.isNoB(vendorImpDto.contactTel)) {
                        vendorImpDto.contactTel = this.replaceSL(vendorImpDto.contactTel, ' ');
                    }
                    if(Utils.isNoB(vendorImpDto.contactTel)) {
                        vendorImpDto.validateInfo.contactTel = {
                            validateOk: false,
                            errorMsg: "[联系手机号]单元不可为空"
                        };
                    } else if(!Utils.isPhoneNo(vendorImpDto.contactTel)) {
                        vendorImpDto.validateInfo.contactTel = {
                            validateOk: false,
                            errorMsg: "[联系手机号]格式不正确"
                        };
                    }
                    //
                    if(Utils.isNoB(vendorImpDto.dateStart)) {
                        vendorImpDto.validateInfo.dateStart = {
                            validateOk: false,
                            errorMsg: "[关系开始日期]单元不可为空"
                        };
                    }
                    if(Utils.isNoB(vendorImpDto.dateEnd)) {
                        vendorImpDto.validateInfo.dateEnd = {
                            validateOk: false,
                            errorMsg: "[关系截止日期]单元不可为空"
                        };
                    } else if(!Utils.isNoB(vendorImpDto.dateStart) && vendorImpDto.dateEnd < vendorImpDto.dateStart){
                        vendorImpDto.validateInfo.dateEnd = {
                            validateOk: false,
                            errorMsg: "[关系截止日期] 不能早于 [关系开始日期]"
                        };
                    }
                    if(Utils.isNoB(vendorImpDto.bizDesc) || vendorImpDto.bizDesc.length > 60) {
                        vendorImpDto.validateInfo.bizDesc = {
                            validateOk: false,
                            errorMsg: "[业务描述]单元不可为空且不能超过60个字符"
                        };
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.vendorImpDto.impInfoList = rows;
                this.setPageVendorImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.vendorImpDto.impInfoList.forEach(function (row) {
                        if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.vendorImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageVendorImpInfoList: function () {
                let totalRows = this.vendorImpDto.impInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                //
                this.pageVendorImpList = totalRows.slice(start, end);
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageVendorImpInfoList();
            },
            // 导出
            downloadVendorImpModel: function () {
                let impInfoList = this.vendorImpDto.impInfoList || [];
                let theLoad = MsgBox.loading();
                vendorApi.vendorImpModelForExport(impInfoList, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 逐条检查
            validateVendorImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                let vendorImpDto = this.vendorImpDto;
                //
                let srcDevcDefImpInfoList = vendorImpDto.impInfoList || [];
                let srcListLength = srcDevcDefImpInfoList.length;
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcDevcDefImpInfoList[checkNextIndex];
                //
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                vendorApi.validateVendorImpModel([srcImpInfo], function (result) {
                    theLoading.hide();
                    let callItem = result.data[0] || {};
                    if(result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcDevcDefImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    vendorImpDto.srcDevcDefImpInfoList = srcDevcDefImpInfoList;
                    self.vendorImpDto = Utils.merge({}, vendorImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    //
                    if(checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateVendorImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doVendorImpModelImport(){
                let self = this;
                let vendorImpDto = this.vendorImpDto;
                // 判断全部的状态是否是ok
                let srcVendorImpInfoList = vendorImpDto.impInfoList || [];
                let srcListLength = srcVendorImpInfoList.length;
                //
//                let contactTelList = srcVendorImpInfoList.pluck("contactTel");
//                if((new Set(contactTelList)).size != contactTelList.length) {
//                    MsgBox.warning("联系手机号不可重复，请检查导入信息");
//                    return;
//                }
                for(let i = 0; i < srcVendorImpInfoList.length; i++) {
                    let countTel = 0;
                    let countVendorName = 0;
                    let contactTel = null;
                    let vendorName = null;
                    for(let j = 0; j < srcVendorImpInfoList.length; j++) {
                        if(srcVendorImpInfoList[i].contactTel == srcVendorImpInfoList[j].contactTel) {
                            countTel++;
                        }
                        if(srcVendorImpInfoList[i].vendorName == srcVendorImpInfoList[j].vendorName) {
                            countVendorName++;
                        }
                        if(countTel >= 2 || countVendorName >= 2) {
                            vendorName = srcVendorImpInfoList[j].vendorName;
                            contactTel = srcVendorImpInfoList[j].contactTel;
                            break;
                        }
                    }
                    if(countVendorName >= 2) {
                        MsgBox.warning("供应商名称【" + vendorName + "】不可重复，请检查导入信息");
                        return;
                    }
                    if(countTel >= 2) {
                        MsgBox.warning("联系手机号【" + contactTel + "】不可重复，请检查导入信息");
                        return;
                    }
                }
                //
                if(srcListLength > 500) {
                    //弹出确认框
                    this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doVendorImpModelImportStart();
                    }).catch(function () {

                    });
                } else {
                    self.doVendorImpModelImportStart();
                }
            },
            // 开始导入
            doVendorImpModelImportStart(){
                this.startFlag = true;
                //
                this.startDone();
            },
            startDone(){
                let self = this;
                let nextIndex = this.nextIndex;
                let srcDeviceImpDto = this.vendorImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.impInfoList || [];
                let srcListLength = srcDeviceImpInfoList.length;
                let srcImpInfo = srcDeviceImpInfoList[nextIndex];
                //
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                vendorApi.doVendorImpModelImport(srcImpInfo, function (result) {
                    theLoading.close();
                    let resultDto = result.data;
                    if(result.type == 'info') {
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                    }
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (nextIndex + 1) / pageSize;
                    let pageNumber2 = (nextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    if(!Utils.isNoB(resultDto) && !Utils.isNoB(resultDto.errMsg)) {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = resultDto.errMsg;
                        self.handlePageChange(pageNumber);
                        MsgBox.warning("源件行号：" + srcImpInfo.rowNo + "】:" + resultDto.errMsg);
                    } else {
                        self.handlePageChange(pageNumber);
                        //
                        if(nextIndex < (srcListLength - 1)) {
                            self.nextIndex = nextIndex + 1;
                            self.startDone();
                        } else {
                            self.$emit('other-close');
                        }
                    }
                });
            },
            replaceSL(str, char){
                if(!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
            setDate(type, formatType) {
                let self = this;
                if(self.multipleSelection.length == 0) {
                    self.$message.warning("请勾选要设置的行");
                    return;
                }
                let theDlg = Vue.$showDialog({
                    title: '选择日期',
                    width: 300,
                    height: 200,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-shop-device-imp-set-date :formatType="formatType" ref="swb_shop_device_imp_set_date"></swb-shop-device-imp-set-date>' +
                    '</div>',
                    data: {
                        formatType: formatType
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_shop_device_imp_set_date.getDlgResult() || {};
                        if(result.type == "info") {
                            let selectDate = result.data;
                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                self.multipleSelection[i][type] = selectDate;
                            }
                            self.checkData();
                            return true;
                        } else {
                            self.$message.warning(result.message);
                        }
                        return false;
                    },
                    methods: {}
                });
            },
            setDateStart(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("dateStart");
                            }
                        }
                    }, '设置')
                ])
            },
            setDateEnd(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("dateEnd");
                            }
                        }
                    }, '设置')
                ])
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/merchant/VendorImpCheck.vue